import { z } from 'zod';

const flag = z.number().nullish();
const text = z.string().nullish();

/** Chaves sem as quais o UYZY não sobe: API principal e o app client do Cognito (U05). */
export const requiredConfigSchema = z.looseObject({
  CREDIT_API_URL: z.string().min(1),
  USER_POOL_ID: z.string().min(1),
  USER_CLIENT_ID: z.string().min(1),
});

const featureFlagValue = z.union([z.string(), z.boolean(), z.number(), z.null()]);

/**
 * Chaves que a casca lê (discovery/03 §9.3). O resto do JSON passa sem validação: o legado tem 110+
 * chaves e cada módulo tipa as suas quando migrar.
 */
export const runtimeConfigSchema = z.looseObject({
  CREDIT_API_URL: z.string().min(1),
  BILLING_API_URL: text,
  BANKING_API_URL: text,
  SEARCH_API_URL: text,
  CHATBOT_API_URL: text,

  USER_POOL_ID: z.string().min(1),
  USER_CLIENT_ID: z.string().min(1),
  USE_MFA: flag,

  MAIN_TITLE: text,
  MAIN_LOGO: text,
  MAIN_FAVICON: text,
  PALETTE: z.record(z.string(), z.unknown()).nullish(),

  TENANT_TYPE: flag,
  USE_TENANT_FILTER: flag,
  SELETOR_TENANTS: flag,
  IS_KOVR: z.boolean().nullish(),

  INITIAL_ROUTE: text,
  /** Endereço do UYZY legado, para onde vão os itens de menu ainda não migrados (U15). */
  LEGACY_BASE_URL: text,
  NATURAL_PERSON_MENU: flag,
  LEGAL_PERSON_MENU: flag,
  CONCILIATION_MENU: flag,
  DESCONTO_MENU: flag,
  BANK_ACCOUNT_PRODUCT_MENU: flag,
  CREDIT_PRODUCT_MENU: flag,
  FUND_MENU: flag,
  ENABLE_NEW_SIMULATION: flag,
  ENABLE_AUTHORIZATION_MANAGEMENT: flag,
  ENABLE_DATAPREV_TEST: flag,
  USE_SIMPLIFIED_INTERNET_BANKING: flag,
  ACTIVE_AUTO_OUTSIDE_MENU: flag,

  FEATURE_FLAGS: z.record(z.string(), featureFlagValue).nullish(),
  FORM_FIELDS: z.record(z.string(), z.unknown()).nullish(),
  PERCENTAGE_DECIMAL_SCALE: flag,

  TIMER_TO_NOTIFICATION_IN_SECONDS: flag,

  CAIS_ENABLED: flag,
  CAIS_SCRIPT_URL: text,
  CAIS_API_URL: text,
  CAIS_AGENT_KEY: text,
  // Chave nova (discovery/12, B6): BFF do UY3.Agents que o Luy chama; ausente desliga o chat.
  AGENTS_BFF_URL: text,

  // Chave nova (U30): não existe no legado; ausente desliga a telemetria.
  OTEL_COLLECTOR_URL: text,
});

export type RuntimeConfig = z.infer<typeof runtimeConfigSchema>;

export type FeatureFlagName =
  | 'AUTOMATIC_PIX'
  | 'CNPJ_ALPHANUMERIC'
  | 'AUTOMATIC_SPLIT'
  | 'SHOW_REFUSAL_IN_CHATBOT'
  | 'RULES_MENU'
  | 'CAR_EQUITY_RATE_MODE'
  | 'MANDATORY_EMPLOYER';

export type ApiUrlKey = 'CREDIT_API_URL' | 'BILLING_API_URL' | 'BANKING_API_URL' | 'SEARCH_API_URL' | 'CHATBOT_API_URL';
